import React, { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

import ActionButton from '../../../components/ActionButton/ActionButton';
import LoggedOutPage from '../../../../pages/LoggedOutPage/LoggedOutPage';
import WelcomeModal from '../../common_modals/WelcomeModal/WelcomeModal';
import { TranslationKeys } from '../../../../i18n/locales/defaultResources';
import { useI18n } from '../../../../hooks/useI18n';
import {
  ButtonGroupStyle,
  ContainerStyle,
  HeaderStyle,
  MainContentStyle,
} from './styles';
import OnSwitchingBPWarningModal from '../../common_modals/OnSwitchingBPWarningModal/OnSwitchingBPWarningModal';

const components: Record<string, React.ReactElement> = {
  welcomemodal: <WelcomeModal onClose={() => {}} open={true} />,
  loggedout: <LoggedOutPage onLogin={() => {}} />,
  onswitchingbpwarningmodal: (
    <OnSwitchingBPWarningModal
      bp={{
        businessPartnerDisplayName: 'Test',
        businessPartnerNumber: '123456',
        inactive: true,
      }}
      isOpen={true}
      onClose={() => {}}
    />
  ),
  // TODO: Find a way to display the unauthenticated home with a login bar, without the BP box, etc
  // publicpage: <UnauthenticatedHome />,
};

const PublicPagesTranslationTool: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { t } = useI18n();
  const component = searchParams.get('component');
  const [currentComponent, setCurrentComponent] = useState<string | null>(
    component || 'welcomemodal'
  );

  const handleComponentChange = (componentName: string) => {
    setCurrentComponent(componentName.toLowerCase());
  };

  const getComponent = (name: string | null): React.ReactElement => {
    if (name) {
      return components[name.toLowerCase()] || components['welcomemodal'];
    }
    return components['welcomemodal'];
  };

  return (
    <div style={ContainerStyle}>
      <div style={HeaderStyle}>
        <ActionButton
          variant="abort"
          buttonText={t(TranslationKeys.admin_translation_back_to_home)}
          onClickAction={() => {
            navigate('/');
          }}
        />
        <div style={ButtonGroupStyle}>
          {Object.keys(components).map((key) => (
            <ActionButton
              key={key}
              variant="accept-blue-light"
              buttonText={key}
              onClickAction={() => handleComponentChange(key)}
            />
          ))}
        </div>
      </div>
      <div style={MainContentStyle}>{getComponent(currentComponent)}</div>
    </div>
  );
};

export default PublicPagesTranslationTool;
